<template>
  <div class="card-list-data">
    <div class="text-center">
      <div class="mb-5">
        <div class="error-animation">
          <svg class="error-mark" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 52 52">
            <circle class="error-mark__circle" cx="26" cy="26" r="25" fill="none" />
            <path class="error-mark__check" fill="none" d="M16 16 36 36 M36 16 16 36" />
          </svg>
        </div>
      </div>
      <h5 class="text-danger">{{ $t('quick_booking.lbl_booking_failed') }}</h5>
      <p class="mt-3">{{ store.errorMessage || $t('quick_booking.lbl_error_occurred') }}</p>
      <hr />
      <div class="non-printable">
        <div class="d-flex flex-wrap gap-1 justify-content-center">
          <button type="button" class="btn btn-secondary d-flex gap-3" @click="prevTabChange(wizardPrev)">
            <svg width="20" height="20" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-6">
              <path stroke-linecap="round" stroke-linejoin="round" d="M10.5 19.5L3 12m0 0l7.5-7.5M3 12h18" />
            </svg>
            <span>{{ $t('quick_booking.lbl_try_again') }}</span>
          </button>
          <button type="button" class="btn btn-primary d-flex gap-3" @click="reset">
            <svg width="20" height="20" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-6">
              <path stroke-linecap="round" stroke-linejoin="round" d="M12 4.5v15m7.5-7.5h-15" />
            </svg>
            <span>{{ $t('quick_booking.lbl_more_bookings') }}</span>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
<script setup>
import { useQuickBooking } from '../../store/quick-booking'
const store = useQuickBooking()

const props = defineProps({
  wizardNext: {
    default: '',
    type: [String, Number]
  },
  wizardPrev: {
    default: '',
    type: [String, Number]
  },
})
const emit = defineEmits(['tab-change','onReset'])
const reset = () => {
  // emit('onReset')
  window.location.reload()
}

const prevTabChange = (val) => (emit('tab-change', val))
</script>
<style scoped>
  #select-confirm .card-list-data {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .error-mark {
    width: 100px;
    height: 100px;
    border-radius: 50%;
    display: block;
    stroke-width: 2;
    stroke: #e91e63;
    stroke-miterlimit: 10;
    box-shadow: inset 0px 0px 0px #e91e63;
    animation: fill-error .4s ease-in-out .4s forwards, scale .3s ease-in-out .9s both;
    position:relative;
    top: 5px;
    right: 5px;
   margin: 0 auto;
}
.error-mark__circle {
    stroke-dasharray: 166;
    stroke-dashoffset: 166;
    stroke-width: 2;
    stroke-miterlimit: 10;
    stroke: #e91e63;
    fill: #fff;
    animation: stroke 0.6s cubic-bezier(0.65, 0, 0.45, 1) forwards;

}

.error-mark__check {
    transform-origin: 50% 50%;
    stroke-dasharray: 48;
    stroke-dashoffset: 48;
    animation: stroke 0.3s cubic-bezier(0.65, 0, 0.45, 1) 0.8s forwards;
}

@keyframes stroke {
    100% {
        stroke-dashoffset: 0;
    }
}

@keyframes scale {
    0%, 100% {
        transform: none;
    }

    50% {
        transform: scale3d(1.1, 1.1, 1);
    }
}

@keyframes fill-error {
    100% {
        box-shadow: inset 0px 0px 0px 30px #e91e63;
    }
}
</style>
